import ActivityCard from "components/ActivityPanel/ActivityCard";
import React from "react";

interface Props {
  activity: server.dto.ProductTemplateActivity
}

export const ProductTemplateActivityCard = (props: Props) => {
  const { activity } = props;

  return <ActivityCard
    activity={activity}
  >
  </ActivityCard>
}